import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/ban-types */
import React, { useMemo } from 'react';
import { optionsMap, GALLERY_CONSTS, isEditMode } from 'pro-gallery-lib';
import { GalleryUI } from './GalleryUI';
import { utils } from 'pro-gallery-lib';
import ImageItem from '../imageItem';
import IframeVideoPlayer from '../videos/IframeVideoPlayer';
var getPlayButtonComponentByItemType = function (type) {
    if (type === 'video') {
        return React.createElement(GalleryUI, { type: 'videoPlayButton', size: 12 });
    }
    else if (type === '3d') {
        return React.createElement(GalleryUI, { type: 'rotateArrow', size: 60 });
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export default function MediaItem(props) {
    var hasLink = props.hasLink, options = props.options, imageDimensions = props.imageDimensions, showPlayButton = props.showPlayButton, MediaImplementation = props.MediaImplementation, enableImagePlaceholder = props.enableImagePlaceholder, isVideoPlaceholder = props.isVideoPlaceholder, videoPlaceholderUrl = props.videoPlaceholderUrl;
    console.log(showPlayButton, 'showPlayButton');
    var clickAction = options.behaviourParams_item_clickAction, playTrigger = options.behaviourParams_item_video_playTrigger;
    var isMediaPlayable = useMemo(function () {
        if (utils.isSSR()) {
            return false;
        }
        if (playTrigger ===
            GALLERY_CONSTS[optionsMap.behaviourParams.item.video.playTrigger]
                .HOVER ||
            playTrigger ===
                GALLERY_CONSTS[optionsMap.behaviourParams.item.video.playTrigger].AUTO) {
            return true;
        }
        else if (clickAction ===
            GALLERY_CONSTS[optionsMap.behaviourParams.item.clickAction].NOTHING) {
            return true;
        }
        else if (clickAction ===
            GALLERY_CONSTS[optionsMap.behaviourParams.item.clickAction].LINK &&
            !hasLink) {
            return true;
        }
        return false;
    }, [hasLink, playTrigger, clickAction]);
    var createIframePlayer = function () { return (React.createElement(IframeVideoPlayer, { dimensions: imageDimensions, url: isVideoPlaceholder ? videoPlaceholderUrl : props.videoUrl })); };
    var createThumbnail = function (propsOverrides) {
        if (propsOverrides === void 0) { propsOverrides = {}; }
        return enableImagePlaceholder ? (React.createElement(ImageItem, __assign({}, props, { imageDimensions: imageDimensions, id: props.idx, overlay: showPlayButton &&
                !isMediaPlayable &&
                getPlayButtonComponentByItemType(props.type), extraClasses: props.placeholderExtraClasses.join(' ') }, propsOverrides))) : (React.createElement(React.Fragment, null));
    };
    var thumbnail = createThumbnail();
    var iframeVideoPlayer = createIframePlayer();
    var placeholder = (React.createElement(React.Fragment, null,
        thumbnail,
        iframeVideoPlayer,
        props.hover));
    if (!isMediaPlayable) {
        return placeholder;
    }
    if (isEditMode()) {
        return thumbnail;
    }
    return (React.createElement(React.Suspense, { fallback: placeholder },
        React.createElement(MediaImplementation, __assign({}, props, { thumbnail: thumbnail, placeholder: placeholder, thumbnailWithOverride: createThumbnail }))));
}
//# sourceMappingURL=mediaItem.js.map